// Import JS Libraries
import React from 'react';
// Import JS Modules
import PendingPhoto from './photo/pending-photo';
import EditablePhoto from './photo/editable-photo';

const Photo = (
  photo,
  isLastPhoto,
  sizesWithRootImage,
  availableSizes,
  onAdvancedEditPhoto,
  recommendedPrintSize,
  showPreviewWarning,
  recommendedPrintSizeTextForPreview,
  photoComponent = EditablePhoto,
  isSelected,
  layoutProps = {},
) => {
  const photoIsEditable = 'raw_url' in photo;

  if (!photoIsEditable) {
    return <PendingPhoto />;
  }

  return React.createElement(photoComponent, {
    photo,
    isLastPhoto,
    sizesWithRootImage,
    availableSizes,
    onAdvancedEdit: onAdvancedEditPhoto,
    recommendedPrintSize: recommendedPrintSize,
    showPreviewWarning,
    recommendedPrintSizeTextForPreview,
    isSelected,
    layoutProps,
  });
};

export default Photo;
